import { Box, Menu, PopoverOrigin } from '@mui/material';
import { SxProps } from '@mui/system';
import * as React from 'react';

interface IProps {
    button: JSX.Element;
    sx?: SxProps;
    vertical?: number | 'top' | 'center' | 'bottom';
    horizontal?: number | 'center' | 'left' | 'right';
}
export const PositionedMenu: React.FC<IProps> = ({ vertical, horizontal, button, children, sx }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const position: PopoverOrigin | undefined = vertical && horizontal ? { vertical, horizontal } : undefined;

    const props = position ? { anchorOrigin: position, transformOrigin: position } : {};

    return (
        <>
            <Box sx={{ p: 0 }} aria-expanded={open ? 'true' : undefined} onClick={handleClick}>
                {button}
            </Box>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} sx={{ ...sx }} {...props}>
                <Box onClick={handleClose} sx={{ width: '100%', pb: 1.5 }}>
                    {children}
                </Box>
            </Menu>
        </>
    );
};
